import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

 
const getProductCommission = async (id) => {
  const res = await axiosInstance.get(`${backendUrl}/api/commissions/${id}`);
  return res.data;
}; 

const saveProductCommission = async (data) => {
  const res = await axiosInstance.post(`${backendUrl}/api/commissions`, data);
  return res.data;
};

export const updateProductCommission = async (id, data) => {

  const res = await axiosInstance.put(`${backendUrl}/api/commissions/${id}`, data);
  return res.data;
};

 export const fetchProductCommission = async () => {
   
     const res = await axiosInstance.get(`${backendUrl}/api/commissions`);
  return res.data;
  };



 export const deleteProductCommission = async (id) => {
   const res = await axiosInstance.delete(`${backendUrl}/api/commissions/${id}`);
  return res.data;
  };

export default { getProductCommission, saveProductCommission, updateProductCommission , fetchProductCommission,deleteProductCommission };